import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { DashboardlineRQ } from './model/DashboardlineRQ';
import { DashboardlineRS } from './model/DashboardlineRS';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Periodo } from '../app-search-information-by-period/Periodo';
import { Observable } from 'rxjs';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import { Router } from '@angular/router';
import { DialogCustomComponent } from '../app-dialog-custom/app-dialog-custom.component';
import { properties } from '../../../environments/properties';
import { DataChar } from '../app-dashboard-line/model/DataChar';
import { Protocolo } from '../app-enum/Protocolo';
import { AppDashboardRpeGeneratedFlightsService } from './app-dashboard-rpe-generated-flights.service';
import { MatDialog } from '@angular/material/dialog';
import { BaseChartDirective } from 'ng2-charts';


@Component({
    selector: 'app-dashboard-rpe-generated-flights',
    templateUrl: './app-dashboard-rpe-generated-flights.component.html',
    styleUrls: ['./app-dashboard-rpe-generated-flights.component.css'],
    standalone: false
})
export class AppDashboardRpeGeneratedFlightsComponent implements OnInit {

  @Input() identification: string;
  @Input() events: Observable<Periodo>;
  private eventsSubscription: any;

  @Output() dateSelectDashOne = new EventEmitter<NgbDateStruct>();

  public requestRepGen: DashboardlineRQ;
  public responseRepGen: DashboardlineRS[];
  public indexSelectColunRepGen;
  public indexLabelPointRepGen;
  public lineChartDataRepGen: any[] = [{ data: [], label: '' }];
  public lineChartLabelsRepGen: any[] = [];

  public lineChartOptions: (any & { annotation: any }) = {
    responsive: true,
    legend: {
      position: 'top',
    },
    hover:{
      intersect: true,
      mode: "nearest",
    },
    scales: {
      xAxes: [
        {}
      ],
      yAxes: [
        {
          id: 'gerados',
          position: 'left',
        },
      ]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'top',
        display: false
      }
    },
    annotation: {},
    title: {
      display: true,
      text: 'RPE\'s Gerados X Total de Voos'
    }
  };

  public lineChartColors: any[] = [];
  public lineChartLegend = true;
  public lineChartType = 'bar';
  public lineChartPlugins = [pluginAnnotations];

  @ViewChild(BaseChartDirective) chart: any;

  constructor(

    private router: Router,
    private dashboardRpeGeneratedService: AppDashboardRpeGeneratedFlightsService,
    public dialog: MatDialog) {
    this.requestRepGen = new DashboardlineRQ();
    this.responseRepGen = new Array<DashboardlineRS>();
    this.requestRepGen.dtInicio = this.getFormatDateToRqRpeGen(this.getActualStartDateToFirstApresentationRpeGenFl());
    this.requestRepGen.dtFim =  this.getFormatDateToRqRpeGen(this.getActualEndDateToFirstApresentationRpeGen());
    this.getDataDashboardLine(null);

  }

  public chartClicked(e: any): void {
    // console.log('clicked chart rpe x voo')
    if (e.active.length > 0) {
      this.indexSelectColunRepGen = e.active[0]._index;
      this.indexLabelPointRepGen = e.active[0].$datalabels.$context.dataset.label;

      if (this.indexLabelPointRepGen == 'Gerados') {
        if (this.lineChartDataRepGen[0].data[this.indexSelectColunRepGen] == 0) {
          this.openDialogRpeGen(
            properties.MODAL_TITLE_PERIOD_SELECT_ATENCION,
                properties.MODAL_CONTENT_INDICATORS_DATA_NOT_FOUND
          );
          return;
        }
      }

      if (this.indexLabelPointRepGen == 'Total'){
          this.openDialogRpeGen(
            properties.MODAL_TITLE_PERIOD_SELECT_ATENCION,
                properties.MODAL_CONTENT_RPE_GERADOS
          );
          return;
      }

      this.router.navigate(['dashboardRpeGeneratedPizza', this.lineChartLabelsRepGen[this.indexSelectColunRepGen], this.indexLabelPointRepGen]);
    }
  }

  ngOnInit() {
    this.eventsSubscription = this.events.subscribe((periodo) => this.getDataDashboardLine(periodo));
  }

  private getDataDashboardLine(periodo: Periodo): void {

    if (periodo != undefined || periodo != null) {
      this.requestRepGen.dtInicio = periodo.getDtInicio();
      this.requestRepGen.dtFim = periodo.getDtFim();
    }

    let rs: DashboardlineRS[];
    this.dashboardRpeGeneratedService.getDataByDate(this.requestRepGen).subscribe(
      data => {
        rs = data;
        // console.log("Data: ", rs);
      },
      err => {
        const protocolo: Protocolo = err.error;
        //console.log(protocolo);
        this.setDashBoardNull();
        this.openDialogRpeGen(
          properties.MODAL_TITLE_PERIOD_SELECT_ATENCION,
              properties.MODAL_CONTENT_DASHBOARD_ERROR_DATA_NOT_FOUND
        );
      },
      () => {
        const dataChar = new DataChar();
        const arrayData = new Array();

        /**
         * ORDENADO RESPOSTA PELA DATA DO VOO
         */
        rs.sort(function(a, b) {
          return a.dtVoo < b.dtVoo ? -1 : a.dtVoo > b.dtVoo ? 1 : 0;
        });

        this.lineChartLabelsRepGen = [];

        //TESTE INSERCAO

        this.lineChartDataRepGen = [{ data: [], label: '' }];
        this.lineChartDataRepGen.splice(0, this.lineChartDataRepGen.length);

        let dataAuto: DataChar = new DataChar();
        let dataManual: DataChar = new DataChar();
        dataAuto.label = 'Gerados';
        dataManual.label = 'Total';

        var arrayDataAuto = new Array();
        var arrayDataManual = new Array();

        for (const value of rs) {

          /**
           * VALIDANDO SE JA EXISTE A DATA NO VETOR DE DATAS
           */
          if(!this.inVector(this.getFormatDate(value.dtVoo))){
            this.lineChartLabelsRepGen.push(this.getFormatDate(value.dtVoo));
            // console.log("VER GRAFICO");
          }

          if (value.type == 'G'){
            arrayDataAuto.push(value.qntRpe);
          } else if(!this.inVectorAutomatic(rs, value.dtVoo)){
            arrayDataAuto.push(0);
          }

          if (value.type == 'T'){
            arrayDataManual.push(value.qntRpe);
          } else if(!this.inVectorManual(rs, value.dtVoo)){
            arrayDataManual.push(0);
          }

        }

        dataAuto.data = arrayDataAuto;
        dataManual.data = arrayDataManual;

        this.lineChartDataRepGen.push(dataAuto);
        this.lineChartDataRepGen.push(dataManual);

        this.setColorsLine();
        // dataChar.data = arrayData;
        // this.getDataToChar(dataChar);
      }
    );
  }

  private inVector(date: any){
    // console.log("[[ INFO ]] VERIFICANDO SE EXISTE ESSA DATA: " + date);
    let control: boolean = false;
    for (const myDate of this.lineChartLabelsRepGen) {
      if (myDate == date) {
        control = true;
        break;
      }
    }
    return control;
  }

  private inVectorAutomatic(rs: DashboardlineRS[], actualDate: any): boolean{

    let control = false;
    for (const value of rs) {
      if(value.type == 'G' && this.getFormatDate(value.dtVoo) == this.getFormatDate(actualDate)){
        control = true;
        break;
      }
    }

    return control;
  }

  private inVectorManual(rs: DashboardlineRS[], actualDate: any): boolean{

    let control = false;
    for (const value of rs) {
      if (value.type == 'T' && this.getFormatDate(value.dtVoo) == this.getFormatDate(actualDate)) {
        control = true;
        break;
      }
    }

    return control;
  }

  /**
   * FUNCAO PARA FORMATAR A DATA APRESENTADA NA LEGENDA DOS GRAFICOS
   * @param dt
   */

  private getFormatDate(dt: any): string {
      if ( dt === null || dt === undefined) {
        return '';
      }
      let dtarr: string[];
      dtarr = dt.split('T');
      dtarr = dtarr[0].split('-');
      return dtarr[2] + '/' + dtarr[1] + '/' + dtarr[0];
  }

  private setColorsLine(): void {
    this.lineChartColors = [
        {
          backgroundColor: 'rgba(255,0,136,1)',
          borderColor: 'rgba(255,0,136,1)',
          pointBackgroundColor: 'rgb(255,245,245)',
          pointRadius: 10,
          pointHoverRadius: 10,
          pointStyle: 'circle',
          borderWidth: 2,
        },
        {
          backgroundColor: 'rgba(27,0,136,1)',
          borderColor: 'rgba(27,0,136,1)',
          pointBackgroundColor: 'rgb(245,245,245)',
          pointRadius: 10,
          pointHoverRadius: 10,
          pointStyle: 'circle',
          borderWidth: 2,
        }
    ];
    // ng2-charts v3+ removeu o input [colors]; as cores agora ficam no dataset
    this.lineChartDataRepGen.forEach((dataset: any, index: number) => {
      Object.assign(dataset, this.lineChartColors[index] ?? this.lineChartColors[0]);
    });
  }

  private getActualEndDateToFirstApresentationRpeGen(): Date {
    return new Date();
  }

  private getActualStartDateToFirstApresentationRpeGenFl(): Date {
    const date: Date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  }

  private setDashBoardNull(): void {
    this.indexSelectColunRepGen = null;
    this.lineChartDataRepGen =  [{ data: [], label: '' }];
    this.lineChartLabelsRepGen = [];
  }

  public openDialogRpeGen(titleParam: string, messageParam: string): void {
    const dialogRef = this.dialog.open(DialogCustomComponent, {
        width: '450px',
        data: {title: titleParam, message: messageParam}
    });
  }

  private getFormatDateToRqRpeGen(date: Date): string {
    return date.getFullYear()
      + '-' + (date.getMonth() + 1 )
        + '-' +  date.getDate();
  }

}
